/*
This component is used to display a list of export options for Showbie assessments.
*/
import * as React from 'react';

import { translate } from '~l10n/client';
import { Divider } from '~shared/components/Divider';
import { IconChevron } from '~shared/components/icons/standard';
import { Stack } from '~shared/components/Stack';

export type ReportKey =
  | 'whole-class-excel'
  | 'student-pdfs'
  | 'results-summary'
  | 'answer-key';

type Item = {
  key: ReportKey;
  /** To allow the tools to extract this string, and for the translate call to run at runtime, this is a function */
  label: () => string;
  disabled?: boolean;
};

const ITEMS: Item[] = [
  {
    key: 'whole-class-excel',
    label: () => translate('Complete Results Excel'),
  },
  { key: 'student-pdfs', label: () => translate('Individual Student PDFs') },
  { key: 'results-summary', label: () => translate('Results Summary PDF') },
  { key: 'answer-key', label: () => translate('Answer Key PDF') },
];

export function AssessmentsExportReportsList({
  onSelect,
  items = ITEMS,
}: {
  onSelect: (key: ReportKey) => void;
  items?: Item[];
}) {
  return (
    <ul
      role="menu"
      aria-label={translate('Export Results')}
      className="w-full -mt-4"
    >
      {items.map((item) => (
        <li key={item.key} role="none">
          <Stack dividers>
            <div
              role="menuitem"
              onClick={() => !item.disabled && onSelect(item.key)}
              className={`w-full flex items-center justify-between py-4 bg-transparent hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 ${
                item.disabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'cursor-pointer'
              }`}
            >
              <p
                className="m-0 truncate text-sm leading-6 text-blue-900 font-500"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {item.label()}
              </p>
              <div className="text-blue-900">
                <IconChevron direction="right" />
              </div>
            </div>
          </Stack>
          <Divider />
        </li>
      ))}
    </ul>
  );
}
